<template><div><h1 id="sammelerfassung-merkmale" tabindex="-1"><a class="header-anchor" href="#sammelerfassung-merkmale"><span>Sammelerfassung Merkmale</span></a></h1>
<p>Sammelerfassung Merkmale — Erfasst Merkmale in einer Sammelbearbeitung</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>In dieser Ansicht können Merkmale zu Personen in einer Sammelerfassung zugeordnet werden. Eingabe der Personen-ID und das entsprechende Merkmal. Nach jeder erfassten Zeile wird automatisch die nächste Zeile mit dem zuletzt erfassten Merkmal als Vorschlag geöffnet.</p>
<p>Pfad: <code v-pre>Personen → Verarbeitungsläufe → Sammelerfassung → Merkmale</code></p>
<h2 id="datenfelder-sammelerfassung-merkmale-zu-person" tabindex="-1"><a class="header-anchor" href="#datenfelder-sammelerfassung-merkmale-zu-person"><span>Datenfelder (Sammelerfassung Merkmale zu Person)</span></a></h2>
<dl>
<dt>Personen-ID</dt>
<dd>Personen-ID für die das Merkmal erfasst werden soll.</dd>
<dt>Name und Adresse</dt>
<dd>Einzeilige Anzeige der Person mit Adresse.</dd>
<dt>Gesamt</dt>
<dd>Anzahl Datensätze (Personen) im Filter die zu bereinigen sind.</dd>
<dt>Merkmal</dt>
<dd>Personenmerkmal, zuletzt erfasstes Merkmal wird vorgeschlagen.</dd>
</dl>
<h2 id="datenfelder-person" tabindex="-1"><a class="header-anchor" href="#datenfelder-person"><span>Datenfelder (Person)</span></a></h2>
<dl>
<dt>Keine Labels</dt>
<dd>Anzeige der Personenmaske (mit Details zur Person)</dd>
</dl>
<h2 id="datenfelder-merkmale" tabindex="-1"><a class="header-anchor" href="#datenfelder-merkmale"><span>Datenfelder (Merkmale)</span></a></h2>
<dl>
<dt>Merkmal</dt>
<dd>Merkmal zu Person.</dd>
<dt>Beschreibung</dt>
<dd>Beschreibung des Merkmals.</dd>
<dt>Wert</dt>
<dd>Wert des Merkmals.</dd>
<dt>von</dt>
<dd>Gültigkeit des Merkmals, gültig von.</dd>
<dt>bis</dt>
<dd>Gültigkeit des Merkmals, gültig bis.</dd>
<dt>A</dt>
<dd>Zeigt an, ob ein Attachment zum Merkmal anghängt ist.</dd>
</dl>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.tbladrmerkmal.html" title="Personenmerkmal">Personenmerkmal</RouteLink></p>
</div></template>


